/** Shared field validation for the sign-in / sign-up / reset-password forms. */

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNonAlphanumeric = /[^a-zA-Z0-9]/.test(password);
  return hasLowerCase && hasUpperCase && hasNonAlphanumeric;
};
